 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		26: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"4":"npm.quill","5":"npm.react-dom","6":"npm.react-quill","9":"npm.babel","10":"npm.emoji-picker-react","11":"npm.react-dd-menu","12":"npm.react-papaparse","13":"npm.react-player","14":"npm.readable-stream","18":"npm.canvg","19":"npm.create-react-class","20":"npm.d3-scale","21":"npm.dompurify","22":"npm.react-querybuilder","23":"npm.react-smooth","24":"npm.react-sortable-hoc","25":"npm.recharts"}[chunkId]||chunkId) + "." + {"1":"fb75257a559b23533fbf","2":"c6d9cbeeaaba074144e2","3":"4d54d4e3b878356cf28d","4":"94241da72c1fa6de79ff","5":"20e1f75c922e3d3f3034","6":"1acd51c2bb65d54eae71","7":"b1a7f85980cb9e32fb9d","8":"458b825d35cd8665c00a","9":"f40e9c0a0b4d005967f9","10":"21a38bb82de79c442dfe","11":"47789c9e20963bf6c053","12":"c20eb5721b6e0b9a02fe","13":"78e80c658ae144c5937f","14":"595c4fa04c9c98f5417f","15":"501f2b68e8bb779cfc7a","18":"60801fedcbcbf194cedb","19":"df2336024ddc5dc39567","20":"53276394962f6600858a","21":"f98419d4cc8ed9b581bb","22":"aea9a033bfa0e2e2ff81","23":"60be86c4cd67c3937270","24":"754bb30c4f2a452a4882","25":"9df6564a3d733b74319f","27":"a660405def7fc51e55ed","28":"6af5496333baaaf74666","29":"69977cf3e6371c0d0b54","30":"0be671899e1f614502be","31":"c39a231734459c968e10","32":"adc87c676459780d98d6","33":"2df83946fbabf70019eb","34":"71636f913dad62caebe1","35":"975dab06ec7c1967c4d4","36":"b469155565264c45f9bb","37":"e59f12068416bb30d584","38":"e7b9a196274e29c24eef","39":"6b09381705591cf23776","40":"87bf4e601f07a9b2d926","41":"8fcb01c7df1ebf89d0d1","42":"e003eab9f4cc49bacab1","43":"5b4becf365062381e661","44":"86d08263df69ace333d2","45":"4d84e9d5971d0d9790d0","46":"7ce4f6bfcfb21ba531a9","47":"a91e1d4ae87a66337ec6","48":"7d4cd1a13491bb04b858","49":"6bfd34b0dd22eb749110","50":"d1ebd64607f1c8ec3138","51":"8e9d31b51cee0db02ebe","52":"319ea407215f278c0dc6","53":"213a78553fcdd4270aaa","54":"3932de21a4c218e13468","55":"73803fab01bfe127768e","56":"a54dc081e0c7c87d6eaf","57":"ca6028806a85e9c9f304","58":"fa2884b2378042a7386f","59":"3167a25e407c3c90f032","60":"8350e8349df9dc99a05a","61":"6b2e94b73f5b236f794f","62":"8e41973803a0a036c909","63":"f2b892cf1be5cfff05ab","64":"f55221731c2d06f04ca2","65":"844e5bb410e4103563d4","66":"6697817c6663c64cea94","67":"4dfce4653f0ab67fcad9","68":"9a65e10f9faf18454fba","69":"59b716a34f8fae0a385e","70":"a6f948899f8cafa9c94e","71":"3a114ee8493eb28353a2","72":"109e39cf4c23ec0f57ad","73":"599922b89865fac1642e","74":"6ac946be395e0fa76956","75":"bcc7df54336d4070d61b","76":"64d635520c0ea71d3cd2","77":"37bc5a9f1409e65283e4","78":"a0ad5c5cb864b8d94888","79":"e1d79f64117d509a781f","80":"86a564da177b0a89905b","81":"18435d8ce11c3634c7d8","82":"e3d96d385457639cf2e3","83":"12446dc22333bdd6f645","84":"c16274fe824a2c23d4dd","85":"4a7918fb19b65523eae3"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/9d01517/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
